import { documentTypeActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  getDocumentTypes: null,
  postDocumentType: null,
  getDocumentTypeById: null,
  deleteDocumentType: null,
  master_Data: null
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case documentTypeActionTypes.get_documenttype.REQUEST:
    return {
      ...state,
      loading: true,
      getDocumentTypes: null,
    };
  case documentTypeActionTypes.post_documenttype.REQUEST:
    return {
      ...state,
      loading: true,
      postDocumentType: null,
    };
  case documentTypeActionTypes.get_documenttype.SUCCESS:
    return {
      ...state,
      loading: false,
      getDocumentTypes: payload,
    };
  case documentTypeActionTypes.post_documenttype.SUCCESS:
    return {
      ...state,
      loading: false,
      postDocumentType: payload,
    };
  case documentTypeActionTypes.get_documenttype.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case documentTypeActionTypes.delete_documenttype.REQUEST:
    return {
      ...state,
      loading: true,
      deleteDocumentType: null,
    };
  case documentTypeActionTypes.delete_documenttype.SUCCESS:
    return {
      ...state,
      deleteDocumentType: payload,
      loading: false,
    };
  case documentTypeActionTypes.get_documenttype_by_id.REQUEST:
    return {
      ...state,
      loading: true,
      getDocumentTypeById: null,
    };
  case documentTypeActionTypes.get_documenttype_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      getDocumentTypeById: payload,
    };
  case documentTypeActionTypes.get_masterData.REQUEST:
    return {
      ...state,
      loading: true,
      master_Data: null,
    };
  case documentTypeActionTypes.get_masterData.SUCCESS:
    return {
      ...state,
      loading: false,
      master_Data: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterDocumentTypesStaff/reducers/MasterDocumentTypesStaffReducers.js